module.exports = __webpack_public_path__ + "img/SES_235140001.08fb78e0.jpg";